import type { CMSConfig } from '#types/config/components/cms'

export default {
  brandClasses: {},
} satisfies CMSConfig['bannerOverlay']
